var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-wrapper',[_c('map-nav',{attrs:{"mapWidth":"100%","mapHeight":"480px"}}),_c('summary-nav'),_c('nodelist-nav')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }